// Which building names get drawn this frame: a handful, never overlapping each other or the HUD.
// Pure so it can be unit-tested; the DOM side lives in labels.ts.
export interface LabelCand { key: any; x: number; y: number; score: number; w: number }
export interface Rect { x0: number; y0: number; x1: number; y1: number }
export const LABEL_H = 24;
export function hudExclusions(W: number, H: number): Rect[] {
  return [
    { x0: 0, y0: 0, x1: W, y1: 118 },                 // score · status · clock
    { x0: 0, y0: 118, x1: 340, y1: 240 },             // chain / objective
    { x0: W - 260, y0: 118, x1: W, y1: 150 },         // track name
    { x0: 0, y0: H - 250, x1: 230, y1: H },           // minimap
    { x0: W - 240, y0: H - 250, x1: W, y1: H },       // camera
    { x0: W * 0.5 - 300, y0: H - 130, x1: W * 0.5 + 300, y1: H },   // juice bar
  ];
}
const hits = (a: Rect, b: Rect) => a.x0 < b.x1 && a.x1 > b.x0 && a.y0 < b.y1 && a.y1 > b.y0;
// cands: screen positions (label anchor = bottom-centre). Returns the keys to show, best first.
export function pickLabels(cands: LabelCand[], W: number, H: number, max = 7): any[] {
  const taken: Rect[] = hudExclusions(W, H); const out: any[] = [];
  const sorted = [...cands].sort((a, b) => b.score - a.score);
  for (const c of sorted){
    if (out.length >= max) break;
    const r: Rect = { x0: c.x - c.w / 2 - 6, y0: c.y - LABEL_H - 4, x1: c.x + c.w / 2 + 6, y1: c.y + 4 };
    if (r.x0 < 0 || r.x1 > W || r.y0 < 0 || r.y1 > H) continue;
    if (taken.some(t => hits(t, r))) continue;
    taken.push(r); out.push(c.key);
  }
  return out;
}
